/*
*  longitude range : (-180, 180], size = 360
*  latitude range : (-90, 90], size = 180
* */
export const geoJsonWidth = 360;
export const geoJsonHeight = 180;
export const stageRatio = geoJsonWidth / geoJsonHeight;
export const PI2 = Math.PI * 2;
